module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-header-pc"
  }, [_c('div', {
    class: {
      'pc-header-box': true, 'change-header': (_vm.changeHeader || _vm.$route.path === '/faq')
    }
  }, [_c('div', {
    staticClass: "pc-header-content"
  }, [_c('div', {
    staticClass: "logo-in-header"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/home/header_logo.png",
      "alt": ""
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "header-nav"
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v(_vm._s(_vm.$t("index")))])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/download"
    }
  }, [_vm._v(_vm._s(_vm.$t("download")))])], 1), _vm._v(" "), (!_vm.isLoginPage) ? _c('li', {
    staticClass: "signUp"
  }, [_c('router-link', {
    attrs: {
      "to": !_vm.hasToken ? '/register' : '/dashboard'
    }
  }, [_vm._v(_vm._s(_vm.$t("discount1")) + " " + _vm._s(_vm.bigstCount) + _vm._s(_vm.$t("discount2")))])], 1) : _vm._e(), _vm._v(" "), (!_vm.hasToken) ? _c('div', [(!_vm.isLoginPage) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v(_vm._s(_vm.$t("signIn")))])], 1) : _vm._e()]) : _c('div', [_c('li', [_c('account-info')], 1)]), _vm._v(" "), _c('li', {
    staticStyle: {
      "height": "20px"
    }
  }, [_c('choose-lang')], 1)])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7412553a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/plexHeader/mainHeader/MainHeaderPc.vue
// module id = 1354
// module chunks = 1